import { render, staticRenderFns } from "./RiskCenterPanel.vue?vue&type=template&id=72bd7a5e&scoped=true"
import script from "./RiskCenterPanel.vue?vue&type=script&lang=js"
export * from "./RiskCenterPanel.vue?vue&type=script&lang=js"
import style0 from "./RiskCenterPanel.vue?vue&type=style&index=0&id=72bd7a5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bd7a5e",
  null
  
)

export default component.exports